<script>
export default {
    name: "SimpleTaskModelFilter",
    props: {
        filter: Object,
    }
}
</script>

<template>
    <div>
        <v-row dense>
            <v-col cols="12" sm="6" md="4">
                <w-text-field
                    v-model="filter.name"
                    :label="$t('common.name')"
                />
            </v-col>
            <v-col cols="12" sm="6" md="4">
                <w-text-field
                    v-model="filter.description"
                    :label="$t('common.comment')"
               />
            </v-col>
        </v-row>
    </div>
</template>